import React  from 'react';
import {FieldViewProps} from "../../../../render/view";
import ItemId from "../../../../../gd-ui/id/item-id";


export default function FieldTaskId_View(props:FieldViewProps) {

    const value = _.get(props.model, props.field.fieldId, null)

    return <ItemId className={Classes("m-r-10", props.className)}
                   itemId={value}
                   itemUrl="t/"
                   itemUrlId={props.model.id}
                   itemName="Task"
                   copyId={true} copyUrl={true} />
}
